<div id="porto" [ngClass]="{'rtl': (langChosen=='ar')?true:false}">

  <div class="cfc-banner">

    <!--<div class="language_container">-->
    <!--<div *ngIf="(langChosen=='ar')?true:false; else english">-->
    <!--<button class="cfc-language-button" value="en" (click)="languageChange('en')">-->
    <!--<p>English</p>-->
    <!--<div class="flag en"></div>-->
    <!--</button>-->
    <!--</div>-->
    <!--<ng-template #english>-->
    <!--<button class="cfc-language-button" value="ar" (click)="languageChange('ar')">-->
    <!--<p>العربية</p>-->
    <!--<div class="flag ar"></div>-->
    <!--</button>-->
    <!--</ng-template>-->
    <!--</div>-->
    <img src="assets/img/porto/porto-banner-fullwidth.jpg" class="img-responsive hidden-xs" alt="">

    <img src="assets/img/porto/porto-banner-mobile.jpg" class="img-responsive hidden-sm hidden-lg hidden-md" alt="">


  </div>


  <div class="container" style="margin-top:100px;">
    <!--<div class="flex_block" style="justify-content: center">-->
    <!--<div class="go_button yellow-proto square" (click)="showTournaments()">View Tournaments</div>-->
    <!--</div>-->
    <div class="container_inner">

      <div class="margin-horizontal" *ngIf="!eventService.loadEventTournaments;else loadJoined">
        <a href="https://www.gbarena.com/tournaments/{{tournament.code}}" target="_blank"
           *ngFor="let tournament of (eventService.eventTournaments|async)?.data">
          <div class="tournaments_container">
            <div class="bar" style="cursor: pointer;">
              <div class="row">
                <div class=" col-md-5 col-xs-12 zero_margin">
                  <div class="block start tournament-bar-title zero_margin">
                    <!--<div class="pp">-->
                    <!--<img *ngIf="tournament.profile_picture" [src]="tournament.profile_picture"-->
                    <!--alt="Tournament Profile">-->
                    <!--</div>-->
                    <div class="flex_block column" style="flex-grow: 1;">
                      <!-- <p style="color:#bbd34a; text-align:left;" *ngIf="tournament.event?.data">
                         {{tournament.event?.data?.name}}</p>-->
                      <h1>{{tournament.name |truncate:100 }}</h1>
                    </div>
                  </div>
                </div>
                <div class="col-md-7 col-xs-12 zero_margin">
                  <div class="flipper">
                    <div class="bar front">
                      <div class="row">

                        <div class="col-xs-6 zero_margin">

                          <div class="block">
                            <div class="status">
                              <div class="icon"
                                   [ngClass]="{'active':(getStatus(tournament.start_at,tournament.status)=='Open'),
                                   'finished':(getStatus(tournament.start_at,tournament.status)=='Finished'),
                                   'inprogress':(getStatus(tournament.start_at,tournament.status)=='In progress')}"></div>
                              <p>{{getStatus(tournament.start_at,tournament.status)}}</p>
                            </div>
                            <!--<div class="status"-->
                            <!--*ngIf="tournament.status == 'Finished'">-->
                            <!--<div class="icon finished"></div>-->
                            <!--<p>Finished</p>-->
                            <!--</div>-->
                            <!--<div class="status"-->
                            <!--*ngIf="tournament.status == 'Registration Closed'">-->
                            <!--<div class="icon postponed"></div>-->
                            <!--<p>Registration Closed</p>-->
                            <!--</div>-->
                            <!--<div class="status"-->
                            <!--*ngIf="tournament.status == 'In Progress'">-->
                            <!--<div class="icon inprogress"></div>-->
                            <!--<p>-->
                            <!--In Progress</p>-->
                            <!--</div>-->
                          </div>
                        </div>

                        <div class="col-xs-6 zero_margin">
                          <div class="block">
                            <!--<p><i class="icon-calendar"></i><b>{{tournament.start_at}}</b></p>-->
                            <p style="margin: 0">
                              <i class="icon-hourglass"></i>
                              <!--SUNDAY, 29-7-2018-->
                              {{globalService.Date(tournament.start_at)}}
                              {{globalService.Time(tournament.start_at)}}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>

                  </div>
                </div>
                <!--<div class="col-lg-2 col-md-2 col-sm-2 col-xs-12 zero_margin">-->
                <!--<a class="block end">-->
                <!--<i class=" icon-right-1"></i>-->
                <!--</a>-->
                <!--</div>-->
              </div>
            </div>

          </div>
        </a>

        <div class="no-data flex_block column" *ngIf="(eventService.eventTournaments|async)?.data?.length==0">
          <p>No tournaments yet/</p>
        </div>

      </div>
      <ng-template #loadJoined>
        <app-loading-indicator></app-loading-indicator>
      </ng-template>
      <div class="col-lg-12" style="justify-content: center;display: flex;"
           *ngIf="(eventService.eventTournaments|async)?.count>4&&
           (eventService.eventTournaments|async)?.data?.length<(eventService.eventTournaments|async)?.count">
        <div class="go_button yellow-proto square" (click)="loadMoreTournaments()">{{loadMore?'Loading..':'Load More'}}
        </div>
      </div>

    </div>

    <div class="container_inner" style="display: flex;flex-flow: column">
      <div class="col-lg-12" style="justify-content: center;display: flex;" *ngIf="!viewLeaderBoard; else viewBoards">
        <div class="go_button yellow-proto square" (click)="viewLeaderBoard=!viewLeaderBoard">View LeaderBoards</div>
      </div>
      <ng-template #viewBoards>
        <app-leaderboards [language]="language"
                          [leaderboards]="(eventService.eventTournaments|async)?.codes"></app-leaderboards>
      </ng-template>
    </div>

    <div class="row">
      <div class="col-lg-10 col-lg-offset-2 col-xs-12">
        <div class="porto-text-container" style="padding-top:30px;">
          <h1 style="color:#664074; text-transform: uppercase;
                    font-family: proxima-nova-bold-webfont;">{{language.Tournament_rules}}</h1>

          <pre>
                        {{language.Rules}}
                    </pre>
          <div class="character1 hidden-xs">
            <img src="assets/img/porto/fotnite-character-1.png" alt="">
          </div>
        </div>
      </div>

    </div>

    <div class="row" style="margin-top: 50px;">
      <div class="col-lg-5">

        <div class="flex_block" style="justify-content: center; align-items: center">
          <img src="assets/img/porto/tournament.svg" style="width:80%; margin: 0 auto; " alt="Fortnite winners">
        </div>
      </div>
      <div class="col-lg-7">

        <div class="flex_block column " style=" align-items: center;">

          <div class="porto-text-container prize">

            <h1>#1st</h1>
            <p>PS4 + T-shirt</p>
          </div>

          <div class="porto-text-container prize">
            <h1>2nd</h1>
            <p>Controller + T-shirt</p>
          </div>

          <div class="porto-text-container prize">

            <h1>#3rd</h1>
            <p>V-Bucks + T-shirt</p>
          </div>
        </div>

      </div>
    </div>
  </div>
</div>

<!--footer-->
<div class="cfc_footer">
  <a href="https://www.gbarena.com" target="_blank" class="gbarena"><img src="assets/img/GBarena-type.svg"
                                                                         style="width: 80px" alt="GBarena Logo"></a>

  <p style="text-transform: uppercase">This tournament is organized by <a
    href="https://www.gbarena.com/arena/king-of-the-map-kotm/summary" target="_blank">KOTM</a><br>
    <!--Hosted by<a href="https://www.gbarena.com" target="_blank"> GBarena</a>.-->
  </p>

</div>
